export const getEffectiveInsuranceOrderStatus = (
  status: string,
  isExpired: boolean,
) => (status === 'CREATED' && isExpired ? 'CANCELLED' : status)

export const formatInsuranceOrderTimer = (totalSeconds: number) => {
  const secondsLeft = Math.max(0, Math.floor(totalSeconds))
  const minutes = Math.floor(secondsLeft / 60)
  const seconds = secondsLeft % 60

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}
